import React from 'react'

export const ArrowDownIcon = () => (
  <ion-icon id="arrow_concluirDownIcon" name="arrow-down-outline"></ion-icon>
)
